import styled from 'styled-components'
import { Card as BootstrapCard } from 'react-bootstrap'

export const BaseCard = styled(BootstrapCard)`
  background: ${({ theme }) => theme.colors.background.card};
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 0 20px rgba(102, 126, 234, 0.1);
  transition: ${({ theme }) => theme.transitions.default};
  overflow: hidden;
  backdrop-filter: blur(10px);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.5), transparent);
    opacity: 0.6;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 35px 70px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2),
      0 0 30px rgba(102, 126, 234, 0.2);
    border-color: rgba(102, 126, 234, 0.3);
  }

  .card-header {
    background: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: ${({ theme }) => theme.spacing.md};
  }

  .card-body {
    padding: ${({ theme }) => theme.spacing.md};
  }

  .card-footer {
    background: transparent;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: ${({ theme }) => theme.spacing.md};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    .card-header,
    .card-body,
    .card-footer {
      padding: ${({ theme }) => theme.spacing.sm};
    }
  }
`

export interface CardProps {
  $variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'info'
  $gradient?: boolean
}

export const StyledCard = styled(BaseCard)<CardProps>`
  ${({ $variant, $gradient, theme }) => {
    if ($gradient && $variant) {
      return `
        background: ${theme.colors.gradients[$variant]};
      `
    }
    return ''
  }}
`
